export const PROVIDER_LABELS: Record<string, string> = {
  "Tmais::Missions::Providers::RedeemQuantityProvider":
    "Resgatar Recompensa (Qtd)",
  "Tmais::Missions::Providers::AcceptProvider": "Aceitar Missão",
  "Tmais::Missions::Providers::ConsumeTotalAmountProvider":
    "Consumo Total (R$)",
  "Tmais::Missions::Providers::InviteNewUsersProvider":
    "Convidar Novos Usuários",
};
